import mrpHeadingStyle from '../mrp/heading'
import mrpStyles from '../mrp.json'

export default {
  ...mrpHeadingStyle,
  loyaltyFontStyle: {
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '30px',
    'screen-large': {
      fontSize: '28px',
      lineHeight: '35px',
      fontWeight: 400,
      textAlign: 'center'
    }
  },
  paragraphFontStyle: {
    fontSize: '22px',
    fontWeight: 400,
    lineHeight: '33px',
    color: mrpStyles.colors.SecondaryGreyMetal
  }
}
